class CartComponent extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "cart-line-item-status",
    );

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", debouncedOnChange.bind(this));

    document.body.addEventListener("docapp-applied-discount-code-changed", () => {
      this.onCartUpdate();
    });

    document.body.addEventListener("docapp-widgets-updated", () => {
      const input = document.querySelector(".docapp-coupon-input--input");
      const button = document.querySelector(".docapp-coupon-input--button-text");
      
      if (Shopify.locale === "zh-TW") {
        input.placeholder = "優惠碼";
        button.textContent = "使用";
      } else if (Shopify.locale === "zh-CN") {
        input.placeholder = "优惠码";
        button.textContent = "使用";
      }
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe("cart-update", (event) => {
      if (event.source === "cart-component") {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(index) {
    const input = this.querySelector(
      `[data-cart-component-quantity-input][data-index="${index}"]`,
    );
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < parseInt(event.target.min)) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.min,
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max,
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    return fetch(`${routes.cart_url}?section_id=main-cart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-component");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        section: this.dataset.cartComponentSectionId,
        selector: "cart-component",
        replaceSelector: "cart-component",
      },
      {
        section: "cart-icon-bubble",
        selector: ".shopify-section",
        replaceSelector: "#cart-icon-bubble",
      },
      {
        section: "cart-live-region-text",
        selector: ".shopify-section",
        replaceSelector: "#cart-live-region-text",
      },
    ];
  }

  updateQuantity(index, quantity, event, variantId) {
    this.enableLoading(index);

    const body = JSON.stringify({
      line: parseInt(index),
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const eventTarget =
      event.currentTarget instanceof RemoveComponent ? "clear" : "change";

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement = document.querySelector(
          `[data-cart-component-quantity-input][data-index="${index}"]`,
        );
        const items = document.querySelectorAll("[data-cart-component-item]");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(index, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.querySelector(
            section.replaceSelector,
          );

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        const itemIndex = parseInt(index) - 1;
        const updatedValue = parsedState.items[itemIndex]
          ? parsedState.items[itemIndex].quantity
          : undefined;
        let message = "";

        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue,
            );
          }
        }

        this.updateLiveRegions(index, message);

        publish("cart-update", {
          source: "cart-component",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors = document.getElementById("main-cart-errors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(index);
      });
  }

  updateLiveRegions(index, message) {
    const lineItemError = document.querySelector(
      `[data-cart-component-item-error][data-index="${index}"]`,
    );

    if (lineItemError) {
      lineItemError.textContent = message;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(index) {
    const cartItemElements = this.querySelectorAll(
      `[data-cart-component-item][data-index="${index}"] .loading__spinner`,
    );

    cartItemElements.forEach((overlay) => {
      overlay.classList.remove("hidden");
    });

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(index) {
    const cartItemElements = this.querySelectorAll(
      `[data-cart-compoenent-item][data-index="${index}"] .loading__spinner`,
    );

    cartItemElements.forEach((overlay) => {
      overlay.classList.add("hidden");
    });
  }
}

customElements.define("cart-component", CartComponent);

class RemoveComponent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartComponent = this.closest("cart-component");

      cartComponent.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define("remove-component", RemoveComponent);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "input",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
      }, 300),
    );
  }
}

customElements.define("cart-note", CartNote);

class QuantityComponent extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      "quantity-update",
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.min);
    const step = parseInt(this.input.step);
    const mod = (value - min) % step;

    if (mod !== 0) {
      this.input.value = (value + step - mod).toString();
    }

    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;

    if (event.currentTarget.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (
      this.input.min === previousValue &&
      event.currentTarget.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
      const buttonMinus = this.querySelector("button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min),
      );
    }

    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-component", QuantityComponent);
